import QuestionJudge from './view';

export default QuestionJudge;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/step/sub-question/judge/index.js